import React from 'react';
import { InformationMessage } from 'features/nekst-widgets';
import { Button, ButtonColor, ButtonSize, TextLink, useFormContextRequired } from 'ui-builder';
import { CreatePersonRequest } from 'nekst-api';

export function ExternalContactLinkWidget() {
  const formContext = useFormContextRequired<CreatePersonRequest>();

  const unlinkContact = () => {
    const { data } = formContext;

    if (data) {
      formContext.setFormData!({
        ...data,
        externalLinks: [],
      });
    }
  };

  const externalLink = formContext.data?.externalLinks?.[0];

  if (externalLink) {

    let contactLabel = externalLink._contactName;

    if (externalLink._contactEmail) {
      contactLabel += ' (' + externalLink._contactEmail + ')';
    }

    return (
      <InformationMessage>
        This contact will be imported from Follow Up Boss -
        {' '}
        <TextLink href={externalLink._externalProfileUrl} target="_blank">{contactLabel}</TextLink>
        . Any changes made in the form below will be synced with the Follow Up Boss record.
        {' '}
        To unlink a newly created contact from Follow Up Boss, click
        {' '}
        <Button
          text="Here"
          color={ButtonColor.RED}
          onClick={() => {
            unlinkContact();
          }}
          isFilled
          size={ButtonSize.SMALL}
        />
      </InformationMessage>
    );
  } else {
    return null;
  }

}
